import React from 'react';

import { Formik, Form, FormikValues } from 'formik';
import * as yup from 'yup';

import Field from 'components/Field';
import Input from 'components/Input';
import InputSecret from 'components/InputSecret';
import Header from 'components/LogoHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, AcceptButton, Body, GroupButton, TextHeader, ForgotPasswordLink } from './styles';

export interface Props {
  loading: boolean;
  onLogin: (username: string, password: string) => void;
}

const LoginSso = ({ loading, onLogin }: Props) => {
  const { t } = useStoreTranslation();

  const handleSubmit = (data: { username: string; password: string }) => {
    onLogin(data.username, data.password);
  };

  const validationSchema = yup.object().shape({
    username: yup.string().required(),
    password: yup.string().required(),
  });

  const initialValues = {
    username: '',
    password: '',
  };

  return (
    <Container>
      <Formik
        initialStatus={{ rightCheckIfIsValid: true }}
        initialValues={initialValues}
        isInitialValid={(formik: any) => validationSchema.isValidSync(formik.initialValues)}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isValid }: FormikValues) => (
          <Form>
            <Header />
            <Body>
              <TextHeader>
                <h3>{t('loginSso.welcome')}</h3>
              </TextHeader>
              <Field name="username" labelKey="loginSso.username">
                <Input
                  id="username"
                  type="text"
                  placeholder={t('loginSso.usernamePlaceholder')}
                  autoCapitalize="off"
                  autoCorrect="off"
                />
              </Field>
              <Field name="password" labelKey="loginSso.password">
                <InputSecret id="password" placeholder={t('loginSso.passwordPlaceholder')} />
              </Field>
              <ForgotPasswordLink href="/corporate/login/forgotpassword">{t('loginSso.forgotPassword')}</ForgotPasswordLink>
              <GroupButton>
                <AcceptButton disabled={!isValid || loading} value={t('loginSso.loginButton')} loading={loading} />
              </GroupButton>
            </Body>
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default LoginSso;
